import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "loyalty-card__header" };
const _hoisted_2 = { class: "loyalty-card__image-wrap" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
    key: 1,
    class: "loyalty-card__image-placeholder"
};
const _hoisted_5 = { class: "loyalty-card__badges" };
const _hoisted_6 = {
    key: 0,
    class: "ri-global-line me-1"
};
const _hoisted_7 = {
    key: 1,
    class: "ri-store-line me-1"
};
const _hoisted_8 = { class: "loyalty-card__body" };
const _hoisted_9 = { class: "loyalty-card__name" };
const _hoisted_10 = {
    key: 0,
    class: "loyalty-card__desc"
};
const _hoisted_11 = { class: "loyalty-card__meta" };
const _hoisted_12 = { class: "meta-item meta-item--points" };
const _hoisted_13 = { class: "meta-item" };
const _hoisted_14 = { class: "meta-item" };
const _hoisted_15 = { class: "mt-2" };
const _hoisted_16 = {
    key: 0,
    class: "ri-check-line me-1"
};
const _hoisted_17 = {
    key: 1,
    class: "items-count mt-2"
};
const _hoisted_18 = { class: "text-muted small" };
const _hoisted_19 = {
    key: 0,
    class: "loyalty-card__footer"
};
const _hoisted_20 = ["title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["loyalty-card", { 'loyalty-card--inactive': !_ctx.isActive }])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                (_ctx.product.imageUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.product.imageUrl,
                        alt: _ctx.product.name,
                        class: "loyalty-card__image"
                    }, null, 8, _hoisted_3))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[3] || (_cache[3] = [
                            _createElementVNode("i", { class: "ri-gift-2-line" }, null, -1)
                        ]))]))
            ]),
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", {
                    class: _normalizeClass(["badge scope-pill", _ctx.scopeClass])
                }, [
                    (_ctx.product.scope === 'GLOBAL')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                        : (_openBlock(), _createElementBlock("i", _hoisted_7)),
                    _createTextVNode(" " + _toDisplayString(_ctx.product.scope), 1)
                ], 2),
                _createElementVNode("span", {
                    class: _normalizeClass(["badge", _ctx.statusClass])
                }, _toDisplayString(_ctx.isActive ? 'Actif' : 'Inactif'), 3)
            ])
        ]),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h6", _hoisted_9, _toDisplayString(_ctx.product.name), 1),
            (_ctx.product.description)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.product.description), 1))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                    _cache[5] || (_cache[5] = _createElementVNode("i", { class: "ri-coins-line" }, null, -1)),
                    _createElementVNode("span", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.product.pointsCost.toLocaleString()), 1),
                        _cache[4] || (_cache[4] = _createTextVNode(" pts", -1))
                    ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                    _cache[6] || (_cache[6] = _createElementVNode("i", { class: "ri-timer-line" }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.formatDuration(_ctx.product.cartExpiryDuration)), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                    _cache[7] || (_cache[7] = _createElementVNode("i", { class: "ri-checkbox-multiple-line" }, null, -1)),
                    _createElementVNode("span", null, "Max " + _toDisplayString(_ctx.product.maxSelectableItems) + " choix", 1)
                ])
            ]),
            _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", {
                    class: _normalizeClass(["badge options-badge", _ctx.product.optionsPricing === 'FREE' ? 'bg-success' : 'bg-secondary'])
                }, [
                    (_ctx.product.optionsPricing === 'FREE')
                        ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                        : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.product.optionsPricing === 'FREE' ? 'Options incluses' : 'Options facturées'), 1)
                ], 2)
            ]),
            (_ctx.product.availableItems?.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _cache[8] || (_cache[8] = _createElementVNode("i", { class: "ri-restaurant-line me-1 text-muted" }, null, -1)),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.product.availableItems.length) + " produit(s) au choix ", 1)
                ]))
                : _createCommentVNode("", true)
        ]),
        (_ctx.canManage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("button", {
                    class: _normalizeClass(["btn btn-sm", _ctx.isActive ? 'btn-outline-warning' : 'btn-outline-success']),
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('toggle', _ctx.product))),
                    title: _ctx.isActive ? 'Désactiver' : 'Activer'
                }, _toDisplayString(_ctx.isActive ? 'Désactiver' : 'Activer'), 11, _hoisted_20),
                _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-primary",
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('edit', _ctx.product))),
                    title: "Modifier"
                }, " Modifier "),
                _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-danger",
                    onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('delete', _ctx.product))),
                    title: "Supprimer"
                }, " Supprimer ")
            ]))
            : _createCommentVNode("", true)
    ], 2));
}
